export const SHORTHAND_DICTIONARY = [
  { trigger: "!mtg",    expansion: "Meeting",                category: "Schedule" },
  { trigger: "!stnd",   expansion: "Standup",                category: "Schedule" },
  { trigger: "!1on1",   expansion: "1:1",                    category: "Schedule" },
  { trigger: "!retro",  expansion: "Retrospective",          category: "Schedule" },
  { trigger: "!plan",   expansion: "Planning session",       category: "Schedule" },
  { trigger: "!review", expansion: "Review",                 category: "Schedule" },
  { trigger: "!sync",   expansion: "Team sync",              category: "Schedule" },
  { trigger: "!demo",   expansion: "Demo",                   category: "Schedule" },
  { trigger: "!lnch",   expansion: "Lunch",                  category: "Schedule" },
  { trigger: "!appt",   expansion: "Appointment",            category: "Schedule" },
  { trigger: "!todo",   expansion: "To do",                  category: "Tasks" },
  { trigger: "!inprog", expansion: "In progress",            category: "Tasks" },
  { trigger: "!block",  expansion: "Blocked",                category: "Tasks" },
  { trigger: "!wip",    expansion: "Work in progress",       category: "Tasks" },
  { trigger: "!pr",     expansion: "Pull request",           category: "Tasks" },
  { trigger: "!bug",    expansion: "Bug fix",                category: "Tasks" },
  { trigger: "!feat",   expansion: "Feature",                category: "Tasks" },
  { trigger: "!urgent", expansion: "URGENT",                 category: "Tasks" },
  { trigger: "!dep",    expansion: "Deployment",             category: "Tasks" },
  { trigger: "!fyi",    expansion: "For your information",   category: "Communication" },
  { trigger: "!asap",   expansion: "As soon as possible",    category: "Communication" },
  { trigger: "!lmk",    expansion: "Let me know",            category: "Communication" },
  { trigger: "!pls",    expansion: "Please",                 category: "Communication" },
  { trigger: "!thx",    expansion: "Thanks",                 category: "Communication" },
  { trigger: "!re",     expansion: "Regarding",              category: "Communication" },
  { trigger: "!fw",     expansion: "Following up on",        category: "Communication" },
  { trigger: "!ooo",    expansion: "Out of office",          category: "Communication" },
  { trigger: "!eod",    expansion: "End of day",             category: "Time" },
  { trigger: "!eow",    expansion: "End of week",            category: "Time" },
  { trigger: "!eom",    expansion: "End of month",           category: "Time" },
  { trigger: "!q1",     expansion: "Q1",                     category: "Time" },
  { trigger: "!q2",     expansion: "Q2",                     category: "Time" },
  { trigger: "!q3",     expansion: "Q3",                     category: "Time" },
  { trigger: "!q4",     expansion: "Q4",                     category: "Time" },
  { trigger: "!tmrw",   expansion: "Tomorrow",               category: "Time" },
  { trigger: "!nxt",    expansion: "Next week",              category: "Time" },
  { trigger: "!api",    expansion: "API",                    category: "Technical" },
  { trigger: "!db",     expansion: "Database",               category: "Technical" },
  { trigger: "!ui",     expansion: "User interface",         category: "Technical" },
  { trigger: "!ux",     expansion: "User experience",        category: "Technical" },
  { trigger: "!fe",     expansion: "Frontend",               category: "Technical" },
  { trigger: "!be",     expansion: "Backend",                category: "Technical" },
  { trigger: "!repo",   expansion: "Repository",             category: "Technical" },
  { trigger: "!cfg",    expansion: "Configuration",          category: "Technical" },
  { trigger: "!env",    expansion: "Environment",            category: "Technical" },
  { trigger: "!kpi",    expansion: "KPI",                    category: "Business" },
  { trigger: "!okr",    expansion: "OKR",                    category: "Business" },
  { trigger: "!roi",    expansion: "Return on investment",   category: "Business" },
  { trigger: "!mvp",    expansion: "Minimum viable product", category: "Business" },
  { trigger: "!cta",    expansion: "Call to action",         category: "Business" },
  { trigger: "!nda",    expansion: "Non-disclosure agreement", category: "Business" },
  { trigger: "!sla",    expansion: "Service level agreement", category: "Business" },
];

export const SHORTHAND_DICTIONARY_EXTENDED = [];  // kept for back-compat

// Merge all entries
const _all = [...SHORTHAND_DICTIONARY];

// Extended business + phonetic entries
const _ext = [
  { trigger: "!ceo", expansion: "CEO", category: "People" },
  { trigger: "!pm", expansion: "Product Manager", category: "People" },
  { trigger: "!dev", expansion: "Developer", category: "People" },
  { trigger: "!mrr", expansion: "Monthly Recurring Revenue", category: "Finance" },
  { trigger: "!arr", expansion: "Annual Recurring Revenue", category: "Finance" },
  { trigger: "!roi", expansion: "Return on Investment", category: "Finance" },
  { trigger: "!ltv", expansion: "Lifetime Value", category: "Finance" },
  { trigger: "!kpi", expansion: "Key Performance Indicator", category: "Strategy" },
  { trigger: "!okr", expansion: "Objectives and Key Results", category: "Strategy" },
  { trigger: "!mvp", expansion: "Minimum Viable Product", category: "Strategy" },
  { trigger: "!prd", expansion: "Product Requirements Doc", category: "Strategy" },
  { trigger: "!rfp", expansion: "Request for Proposal", category: "Strategy" },
  { trigger: "!api", expansion: "API", category: "Tech" },
  { trigger: "!ux", expansion: "User Experience", category: "Tech" },
  { trigger: "!db", expansion: "Database", category: "Tech" },
  { trigger: "!ci", expansion: "Continuous Integration", category: "Tech" },
  { trigger: "!tbd", expansion: "To be determined", category: "Writing" },
  { trigger: "!tbc", expansion: "To be confirmed", category: "Writing" },
  { trigger: "!tbr", expansion: "To be reviewed", category: "Writing" },
  { trigger: "!eg:", expansion: "e.g.", category: "Writing" },
  { trigger: "!ie:", expansion: "i.e.", category: "Writing" },
  { trigger: "!eod", expansion: "End of day", category: "Schedule" },
  { trigger: "!eow", expansion: "End of week", category: "Schedule" },
  { trigger: "!eom", expansion: "End of month", category: "Schedule" },
  { trigger: "!q1", expansion: "Q1", category: "Schedule" },
  { trigger: "!q2", expansion: "Q2", category: "Schedule" },
  { trigger: "!q3", expansion: "Q3", category: "Schedule" },
  { trigger: "!q4", expansion: "Q4", category: "Schedule" },
  { trigger: "th-", expansion: "the", category: "Phonetic" },
  { trigger: "an-", expansion: "and", category: "Phonetic" },
  { trigger: "fr-", expansion: "from", category: "Phonetic" },
  { trigger: "wt-", expansion: "with", category: "Phonetic" },
  { trigger: "abt-", expansion: "about", category: "Phonetic" },
  { trigger: "mtn-", expansion: "meeting", category: "Phonetic" },
  { trigger: "imp-", expansion: "important", category: "Phonetic" },
  { trigger: "btw-", expansion: "by the way", category: "Phonetic" },
  { trigger: "imo-", expansion: "in my opinion", category: "Phonetic" },
  { trigger: "idk-", expansion: "I don't know", category: "Phonetic" },
];
_ext.forEach(e => { if (!_all.find(x => x.trigger === e.trigger)) _all.push(e); });
// Re-export as the authoritative list
Object.assign(SHORTHAND_DICTIONARY, _all);
SHORTHAND_DICTIONARY.length = 0;
_all.forEach(e => SHORTHAND_DICTIONARY.push(e));

export const SHORTHAND_CATEGORIES = [...new Set(SHORTHAND_DICTIONARY.map(e => e.category))];
